import { PATHOLOGY_MAP_CATEGORY_ITEM_HOVER_BORDER_COLOR } from 'components/PathologyMap/constants/styles';
import { makeStyles } from 'tss-react/mui';
import {
  ERROR_ICON,
  FORM_TEXT_COLOR,
  MEDIUM_GREY,
  WHITE,
  BUTTON_GREY_4,
  DATA_MANAGEMENT_BLUE,
  BLACK_ICON,
  DATA_MANAGEMENT_BLUE_TRANSPARENT,
  TRANSPARENT_BLACK_15,
  SECONDARY_BLUE,
  BUTTON_GREY,
  LIGHT_GREY,
  WHITE_SMOKE,
  WHITE_SMOKE_3,
  TRANSPARENT_BLACK_26,
  LIGHT_GREY_2,
  LIGHT_BLUE_2,
} from 'utilities/colors';
import { VERTICAL_SCROLL_STYLE } from 'themes/defaultMuiTheme';

export const useSlideViewerActionsStyles = makeStyles()((theme) => ({
  expandButton: {
    width: '2.25rem',
    minWidth: '2.25rem',
    height: '2rem',
    marginRight: '2rem',
    '& svg': {
      width: '1.25rem',
      height: '1.25rem',
    },
  },
  colorButton: {
    width: '1.5rem',
    minWidth: '1.5rem',
    height: '1.5rem',
    marginRight: '1rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  colorLegendButtons: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${TRANSPARENT_BLACK_26}`,
    marginBottom: '0.5rem',
    padding: '0.5rem',
  },
  dataProvider: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.5rem 1rem',
    width: '100%',
    margin: '0.5rem 0',
    borderRadius: '0.25rem',
    border: `1px solid ${LIGHT_GREY}`,
    cursor: 'pointer',
    color: BUTTON_GREY_4,
    textTransform: 'none',
    backgroundColor: 'rgba(217, 217, 217, 0.1)',
    '&:hover': {
      backgroundColor: WHITE_SMOKE,
    },
  },
  skeleton: {
    height: '4.25rem',
    borderTop: `1px solid ${TRANSPARENT_BLACK_15}`,
    borderBottom: `1px solid ${TRANSPARENT_BLACK_15}`,
  },
  dataProviderSelected: {
    border: `1px solid ${DATA_MANAGEMENT_BLUE}`,
    backgroundColor: DATA_MANAGEMENT_BLUE_TRANSPARENT,
    '&:hover': {
      backgroundColor: DATA_MANAGEMENT_BLUE_TRANSPARENT,
    },
  },
  providerButtonSelected: {
    backgroundColor: DATA_MANAGEMENT_BLUE,
    position: 'absolute',
    borderRadius: '50%',
    top: '-0.5rem',
    right: '-0.5rem',
    width: '1.1rem',
    height: '1.1rem',
  },
  providerButtonSelectedHidden: {
    display: 'none',
  },
  providerButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  providerIcon: {
    width: '2rem',
    height: '2rem',
    marginRight: '1rem',
  },
  providerIconLarge: {
    width: '3rem',
    height: '3rem',
    [theme.breakpoints.down('laptop')]: {
      width: '2.5rem',
      height: '2.5rem',
    },
  },
  percentageSlider: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '60%',
  },
  accordion: {
    backgroundColor: WHITE,
    padding: '0 0.5re',
  },
  accordionSummary: {
    padding: '0 2rem',
    [theme.breakpoints.down('laptop')]: {
      padding: '0 0.75rem',
    },
    '&.Mui-expanded': {
      backgroundColor: LIGHT_BLUE_2,
    },
    backgroundColor: WHITE_SMOKE_3,
  },
  providerIconContainer: {
    width: '3rem',
    height: '3rem',
    marginRight: '1rem',
    [theme.breakpoints.down('laptop')]: {
      width: '2.5rem',
      height: '2.5rem',
      marginRight: '0.5rem',
    },
  },
  modalTitle: {
    fontSize: '1.1rem',
    fontWeight: 500,
    letterSpacing: '0.1em',
    padding: '1.5rem 0 1rem 1.5rem',
  },
  modalContentWrapper: {
    padding: '2rem 2rem 0 2rem',
  },
  divider: {
    color: TRANSPARENT_BLACK_15,
  },
  actionButton: {
    padding: '0.25rem',
    marginLeft: '1rem',
    width: '2.25rem',
    minWidth: '2.25rem',
    height: '2.25rem',
    border: '1px solid #D2D2D2',
    borderRadius: '0.3rem',
    '& svg': {
      color: BLACK_ICON,
      [theme.breakpoints.down('laptop')]: {
        width: '1.25rem',
      },
    },
    [theme.breakpoints.down('laptop')]: {
      width: '1.8rem',
      minWidth: '1.8rem',
      height: '1.825rem',
      marginLeft: '0.25rem',
    },
  },
  annotationName: {
    fontSize: '1rem',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    [theme.breakpoints.down('xl')]: {
      fontSize: '0.875rem',
    },
    [theme.breakpoints.down('laptop')]: {
      fontSize: '0.75rem',
    },
  },
  annotationAuthor: {
    fontSize: '0.75rem',
    [theme.breakpoints.down('xl')]: {
      fontSize: '0.625rem',
    },
    color: LIGHT_GREY_2,
  },
  annotationTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '70%',
  },
  uploadButton: {
    width: '3rem',
    minWidth: '3rem',
    backgroundColor: DATA_MANAGEMENT_BLUE_TRANSPARENT,
    border: `1px solid ${DATA_MANAGEMENT_BLUE}`,
    borderRadius: '0.25rem',
    cursor: 'pointer',
    textAlign: 'center',
    marginRight: '0.75rem',
    alignItems: 'center',
    '& svg': {
      color: DATA_MANAGEMENT_BLUE,
    },
  },
  shareLabel: {
    '&.MuiButtonBase-root': {
      fontSize: '0.75rem',
    },
    '&.Mui-disabled': {
      color: 'black',
    },
  },
  exportButtonWrapper: {
    width: '100%',
    textAlign: 'center',
    padding: '1.5rem 1.75rem',
  },
  exportButton: {
    width: '100%',
  },
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    padding: '0.8rem 0',
    gap: '0.5rem 1.5rem',
  },
  extAnnotationsActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  actions: {
    '& > *': {
      borderBottom: '1px solid #E0E0E0',
    },

    '& > *:last-child': {
      borderBottom: 'none',
    },
  },
  shareButton: {
    '& .MuiButtonBase-root': {
      [theme.breakpoints.down('xl')]: {
        fontSize: '0.5rem',
        padding: '0.5rem 1rem',
      },
    },
  },
  shareSlide: {
    gridRow: '-1/3',
    gridColumn: '2/3',
  },
  menuBlock: {
    '& > *': {
      borderBottom: '1px solid #E0E0E0',
    },

    '& > *:last-child': {
      borderBottom: 'none',
    },
  },
  menuTitle: {
    color: FORM_TEXT_COLOR,
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0 0 0.3rem 0.5rem',
  },
  menuLabel: {
    fontSize: '1.325rem',
    lineHeight: '87.5%',
    fontVariant: 'all-small-caps',
    whiteSpace: 'nowrap',
    fontWeight: 500,
  },
  menuRow: {
    padding: '0.5rem 0 0.5rem 0.5rem',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    borderLeft: '0.2rem solid transparent',
    borderRight: '0.2rem solid transparent',
    position: 'relative',

    '&:hover': {
      cursor: 'pointer',
      borderLeftColor: PATHOLOGY_MAP_CATEGORY_ITEM_HOVER_BORDER_COLOR,
      borderRightColor: PATHOLOGY_MAP_CATEGORY_ITEM_HOVER_BORDER_COLOR,
      transition: 'border .3s ease',
    },
  },
  actionButtons: {
    display: 'flex',
    gap: '1.5rem',
    flexDirection: 'column',
    paddingBottom: '2rem',
  },
  shareSlideButton: {
    height: 100,
  },
  menuIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: MEDIUM_GREY,
    opacity: 0.7,
  },
  menuRowIcon: {
    width: '0.875rem',
    height: '0.875rem',
    color: MEDIUM_GREY,
    opacity: 0.7,
    marginRight: '1rem',
  },
  menuRowLabel: {
    fontSize: '0.875rem',
    lineHeight: '0.875rem',
    whiteSpace: 'nowrap',
  },
  attachment: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('xl')]: {
      fontSize: '0.875rem',
    },
  },
  label: {
    fontSize: '1rem',
    [theme.breakpoints.down('xl')]: {
      fontSize: '0.875rem',
    },
  },
  visibilityToggle: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.4rem',
    '& svg': {
      cursor: 'pointer',
      color: ERROR_ICON,
    },
  },
  dropzone: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    border: `2px dashed ${DATA_MANAGEMENT_BLUE}`,
    borderRadius: '0.25rem',
    cursor: 'pointer',
    padding: '1rem',
    margin: '1rem 0 2rem 0',
    color: '#484848',
    backgroundColor: DATA_MANAGEMENT_BLUE_TRANSPARENT,
  },
  dropzoneDisabled: {
    border: `2px dashed ${BUTTON_GREY}`,
    cursor: 'not-allowed',
  },
  uploadedFilesList: {
    width: '100%',
    padding: '0 2rem',
    height: '17rem',
    overflowY: 'auto',
    ...VERTICAL_SCROLL_STYLE,
  },
  modalButton: {
    width: '15rem',
    height: '2rem',
    backgroundColor: DATA_MANAGEMENT_BLUE,
    letterSpacing: '0.1em',
    boxShadow: 'none',
  },
  modalButtonProceed: {
    backgroundColor: DATA_MANAGEMENT_BLUE,
    '&:hover': {
      backgroundColor: SECONDARY_BLUE,
    },
  },
  modalButtonCancel: {
    backgroundColor: WHITE,
    color: BLACK_ICON,
    border: `1px solid ${BUTTON_GREY}`,
    '&:hover': {
      backgroundColor: LIGHT_GREY,
    },
  },
  underline: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: DATA_MANAGEMENT_BLUE,
    marginLeft: '0.25rem',
  },
}));

export const useViewerMenuItemStyles = makeStyles()((theme) => ({
  switchWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.2rem',
    paddingBottom: '1rem',
  },
  switch: {
    width: '2.75rem',
    height: '1.125rem',
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(1.625rem)',
        color: '#fff',

        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#1890ff',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: '0.875rem',
      height: '0.875rem',
      borderRadius: '0.5rem',
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  },
  checkedValue: {
    '& .MuiSwitch-switchBase + .MuiSwitch-track::before': {
      position: 'absolute',
      content: '"on"',
      left: 8,
      top: -2,
      color: WHITE,
      fontSize: '0.875rem',
    },
  },
  uncheckedValue: {
    '& .MuiSwitch-switchBase + .MuiSwitch-track::before': {
      position: 'absolute',
      content: '"off"',
      right: 8,
      top: -2,
      color: WHITE,
      fontSize: '0.875rem',
    },
    [theme.breakpoints.down('xxl')]: {
      '& .MuiSwitch-switchBase + .MuiSwitch-track::before': {
        right: 5,
        top: -1,
      },
    },
  },
  label: {
    textTransform: 'uppercase',
  },
}));
